import { authUrl, isTokenValid } from "infra/auth/sso-login";
import { Button } from "primereact/button";
import { Checkbox } from "primereact/checkbox";
import { InputText } from "primereact/inputtext";
import { Password } from "primereact/password";
import React from "react";
import { useSearchParams } from "react-router-dom";
import { getLocalStorageItem, setLocalStorageItem, clearLocalStorage } from "presentation/utils/localStorage";
import { getSessionStorageItem, setSessionStorageItem, clearSessionStorage } from "presentation/utils/sessionStorage";
import logo from "../../../assets/logo.svg";
import "./index.css";

const Login: React.FC = () => {
  const [searchParams] = useSearchParams();
  const unauthorized = searchParams.get("unauthorized") === "true";

  const sessionKey = "auth-session-storage";
  const sessionData = getSessionStorageItem(sessionKey);
  const lastRoute = getLocalStorageItem("lastRoute") ?? "";

  let accessToken: string | null = null;

  if (sessionData) {
    try {
      const parsed = JSON.parse(sessionData);
      accessToken = parsed?.state?.accessToken ?? null;
      const expiresAt = parsed?.state?.expiresAt ?? 0;
      if (
        isTokenValid(expiresAt) &&
        (unauthorized === undefined || unauthorized === false)
      ) {
        // window.location.href =
        //   window.location.origin + (process.env.REACT_APP_BASENAME || "/");
        window.location.href =
          window.location.origin +
          (process.env.REACT_APP_BASENAME || "/") +
          lastRoute;
      } else {
        clearLocalStorage();
        clearSessionStorage();
      }
    } catch (err) {
      console.error("Erro ao parsear auth-session-storage:", err);
    }
  }

  const login = async () => {
    try {
      const authRedirect = await authUrl();
      //console.log("authRedirect", authRedirect);
      setSessionStorageItem("codeVerifier", authRedirect.codeVerifier);
      window.location.href = authRedirect.url;
    } catch (error) {
      console.error("Erro ao obter URL de autenticação:", error);
    }
  };

  return (
    <div className="login-container">
      <div className="login-form">
        <img src={logo} />
        <InputText placeholder="E-mail" className="w-full" disabled />
        <Password
          placeholder="Senha"
          className="input-pt password-full w-full"
          toggleMask
          disabled
        />
        <div className="login-options">
          <div>
            <Checkbox inputId="rememberMe" name="rememberMe" checked={true} />
            <label htmlFor="rememberMe" className="ml-2">
              {" "}
              Lembrar
            </label>
          </div>
          <Button
            className="forget-password"
            label="Esqueceu sua senha?"
            link
            onClick={() => window.open("#")}
          />
        </div>
        <div className="login-button">
          <Button label="Aceder" className="spacing-button" disabled />
          <Button
            label="Aceder com Microsoft"
            className="spacing-button"
            onClick={login}
          />
        </div>
      </div>
      <div></div>
    </div>
  );
};

export default Login;
